import api from '../../services/api';
import { Creators } from '../ducks/product';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { captureSentryException } from '../../utils';

export function* getProducts({ filter }) {
  try {
    yield put(Creators.productRequest());
    const response = yield call(api.post, 'product', filter);

    yield put(Creators.productSuccess(filter.chip, response.data));
  } catch (err) {
    yield captureSentryException(err, filter);
    yield put(Creators.productError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: 'Falha ao listar produtos'
    }));
  }
}